import {
  ApiResponse,
  Staff,
  StaffListResponse,
  CreateStaffRequest,
  UpdateStaffRequest,
  MessageResponse,
} from '@mygate/common';
import { api } from './api';

class StaffService {
  async fetchAllStaff(params?: {
    page?: number;
    pageSize?: number;
    search?: string;
  }): Promise<ApiResponse<StaffListResponse>> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.pageSize) queryParams.append('pageSize', params.pageSize.toString());
    if (params?.search) queryParams.append('search', params.search);

    return api.get(`/api/staff/members?${queryParams.toString()}`);
  }

  async getStaffById(id: string): Promise<ApiResponse<Staff>> {
    return api.get(`/api/staff/members/${id}`);
  }

  async createStaff(data: CreateStaffRequest): Promise<ApiResponse<Staff>> {
    return api.post('/api/staff/members', data);
  }

  async updateStaff(id: string, data: UpdateStaffRequest): Promise<ApiResponse<Staff>> {
    return api.put(`/api/staff/members/${id}`, data);
  }

  async deleteStaff(id: string): Promise<ApiResponse<MessageResponse>> {
    return api.delete(`/api/staff/members/${id}`);
  }
}

export const staffService = new StaffService();
